import styled from 'styled-components';

export const IconWrapper = styled.div`
  background-color: #f5f5f5;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
`;
